import clsx from 'clsx';
import React from 'react';

import type { VideoComponentProps } from './interfaces';

const YouTube = ({ config, content, maxWidth }: VideoComponentProps) => {
  return (
    <iframe
      src={content.src}
      className={clsx(
        'video-block mt-24 h-auto w-full border-0',
        maxWidth,
        content?.yt_short ? 'aspect-[9/16]' : 'aspect-[16/9]',
        config?.css_classes
      )}
      title="YouTube video player"
      allow="accelerometer; autoplay; encrypted-media; gyroscope;"
      referrerPolicy="strict-origin-when-cross-origin"
      allowFullScreen
    />
  );
};

export default YouTube;
